import {IConnectBankFormValues} from "../../../../../../pages/dashboard/payouts/i-connect-bank";
import {TGetPayoutBankBranchesApiResponse} from "../../../../../../react-query-hooks/payout";
import {AccountDetailsFormValues} from "../form/types";

type CurrentStep = {} & (CreateAccountType | UpdateAccountType);

type CreateAccountType = {
  type: "create";
  currentView: "initial" | "form";
};
type UpdateAccountType = {
  type: "update";
  currentView: "initial" | "form" | "otp";
};
type UpdatePayoutBanksPayload = {
  countryCode: string | null;
  banks: {code: string; id: number; name: string; hasBankBranch: boolean}[];
};
type UpdatePayoutBankBranchesPayload = {
  bankId: number | null;
  branches: TGetPayoutBankBranchesApiResponse | null;
};
type UpdatePayoutCountriesPayload = {
  countries: {code: string; currency: string; name: string}[];
};

type TUpdatePayoutSettingsStatus = {
  type: "update-payment-settings-flow";
  payload: CurrentStep;
};
type TUpdatePayoutBanks = {
  type: "update-payout-banks";
  payload: UpdatePayoutBanksPayload;
};
type TUpdatePayoutBankBranches = {
  type: "update-payout-bank-branches";
  payload: UpdatePayoutBankBranchesPayload;
};
type TUpdatePayoutCountries = {
  type: "update-payout-countries";
  payload: UpdatePayoutCountriesPayload;
};
type TUpdateConnectBankFormValues = {
  type: "update-connect-bank-form-values";
  payload: IConnectBankFormValues;
};
type TUpdateConnectBankAccountNameValue = {
  type: "update-connect-bank-account-name-value";
  payload: string | null;
};
type TUpdateConnectBankNameValue = {
  type: "update-connect-bank-name-value";
  payload: string;
};
type TUpdateSelectedCountryCode = {
  type: "update-selected-country-code";
  payload: string;
};
type TUpdateUpdateType = {
  type: "update-update-type";
  payload: "stripe" | "local";
};

type TResetPayoutBanksState = {
  type: "reset-payout-banks-state";
};
type TResetState = {
  type: "reset-state";
};
export type TPayoutSettingsActions =
  | TUpdatePayoutSettingsStatus
  | TUpdatePayoutBanks
  | TUpdatePayoutBankBranches
  | TResetPayoutBanksState
  | TUpdatePayoutCountries
  | TUpdateConnectBankFormValues
  | TUpdateConnectBankAccountNameValue
  | TUpdateConnectBankNameValue
  | TUpdateSelectedCountryCode
  | TUpdateUpdateType
  | TResetState;

type TPayoutSettingsState = {
  currentStep: CurrentStep;
  payoutBanks: {
    countryCode: string | null;
    banks: {code: string; id: number; name: string; hasBankBranch: boolean}[];
  };
  payoutBankBranches: {
    bankId: number | null;
    branches: TGetPayoutBankBranchesApiResponse | null;
  };
  payoutCountries: UpdatePayoutCountriesPayload;
  connectBankFormValues?: AccountDetailsFormValues;
  bankName: string | null;
  accountName: string | null;
  selectedCountryCode: string | null;
  updateType: "stripe" | "local" | null;
};

export const initialPayoutSettingsState: TPayoutSettingsState = {
  currentStep: {
    type: "create",
    currentView: "initial",
  },
  payoutBanks: {
    banks: [],
    countryCode: null,
  },
  payoutBankBranches: {
    branches: null,
    bankId: null,
  },
  payoutCountries: {
    countries: [],
  },
  connectBankFormValues: undefined,
  accountName: null,
  bankName: null,
  selectedCountryCode: null,
  updateType: null,
};

export const payoutSettingsReducer = (
  state: TPayoutSettingsState = initialPayoutSettingsState,
  action: TPayoutSettingsActions
) => {
  if (action.type === "update-payment-settings-flow") {
    return {...state, currentStep: action.payload};
  }
  if (action.type === "update-payout-banks") {
    return {...state, payoutBanks: action.payload};
  }
  if (action.type === "reset-payout-banks-state") {
    return {
      ...state,
      payoutBanks: {
        banks: [],
        countryCode: null,
      },
    };
  }

  if (action.type === "update-payout-bank-branches") {
    return {...state, payoutBankBranches: action.payload};
  }
  if (action.type === "update-payout-countries") {
    return {...state, payoutCountries: action.payload};
  }
  if (action.type === "update-connect-bank-form-values") {
    return {...state, connectBankFormValues: action.payload};
  }
  if (action.type === "update-connect-bank-account-name-value") {
    return {...state, accountName: action.payload};
  }
  if (action.type === "update-connect-bank-name-value") {
    return {...state, bankName: action.payload};
  }
  if (action.type === "update-selected-country-code") {
    return {...state, selectedCountryCode: action.payload};
  }
  if (action.type === "update-update-type") {
    return {...state, updateType: action.payload};
  }
  if (action.type === "reset-state") {
    return {...initialPayoutSettingsState};
  }
  return state;
};
